import { useState, type JSX } from "react";
import { Button } from "../../../components";

// [Type-as-Other] The inline "type your own" box, scoped to one clause — Enter
// sends, Shift+Enter newlines, Escape cancels. Same markup/behaviour as the
// classic card; state resets because the card remounts it per clause (key).
export function ReviewTypeBox({
  clauseName,
  pending,
  onSubmit,
  onCancel,
}: {
  clauseName: string;
  pending: boolean;
  onSubmit: (text: string) => void;
  onCancel: () => void;
}): JSX.Element {
  const [typed, setTyped] = useState("");
  const submit = (): void => {
    const t = typed.trim();
    if (t.length === 0) return;
    onSubmit(t);
  };
  return (
    <div className="sa-rev__type" data-testid="review-type">
      <textarea
        className="sa-rev__type-input"
        autoFocus
        rows={2}
        placeholder={`Tell the agent what to do with “${clauseName}”…`}
        value={typed}
        disabled={pending}
        onChange={(e) => setTyped(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            submit();
          } else if (e.key === "Escape") {
            e.preventDefault();
            onCancel();
          }
        }}
      />
      <div className="sa-rev__type-acts">
        <Button
          variant="bare"
          className="sa-rev__btn sa-rev__btn--apply"
          disabled={pending || typed.trim().length === 0}
          onClick={submit}
        >
          Send
        </Button>
        <Button
          variant="bare"
          className="sa-rev__btn sa-rev__btn--skip"
          disabled={pending}
          onClick={onCancel}
        >
          Cancel
        </Button>
      </div>
    </div>
  );
}
